// Rapor tasarımcısı için merkezi veri alan kataloğu (FastReport tarzı).
// Kullanıcı alan anahtarını ELLE YAZMAZ — buradaki listeden ağaca bakar, sürükler.
//
// Yeni bir veri kaynağı eklemek için:
//   1) FIELD_REGISTRY altına yeni bir `<source_key>: { label, icon, fields: [...] }` kaydı yaz.
//   2) Eğer yeni bir rapor tipi de ekleniyorsa REPORT_DATA_SOURCES'a `<report_key>: { master, detail, context }` ekle.
//   3) StockListReportPage gibi consumer'ın print/data hazırlığında alan anahtarlarının veriyle eşleştiğinden emin ol.

export const FIELD_REGISTRY = {
  // ───── Stok ───────────────────────────────────────────────────
  stock: {
    label: 'Stok',
    icon: '📦',
    fields: [
      { key: 'code',         label: 'Stok Kodu',       type: 'string' },
      { key: 'name',         label: 'Stok Adı',        type: 'string' },
      { key: 'full_name',    label: 'Tam Ad',          type: 'string' },
      { key: 'barcode',      label: 'Barkod',          type: 'string' },
      { key: 'category',     label: 'Kategori',        type: 'string' },
      { key: 'brand',        label: 'Marka',           type: 'string' },
      { key: 'unit',         label: 'Birim',           type: 'string' },
      { key: 'model',        label: 'Model',           type: 'string' },
      { key: 'group_code',   label: 'Grup Kodu',       type: 'string' },
      { key: 'shelf_code',   label: 'Raf Kodu',        type: 'string' },
      { key: 'color',        label: 'Renk',            type: 'string' },
      { key: 'size',         label: 'Beden',           type: 'string' },
      { key: 'vat',          label: 'KDV %',           type: 'number' },
      { key: 'min_stock',    label: 'Min Stok',        type: 'number' },
      { key: 'max_stock',    label: 'Max Stok',        type: 'number' },
      { key: 'reorder_point',label: 'Sipariş Noktası', type: 'number' },
      { key: 'total_qty',    label: 'Toplam Miktar',   type: 'number' },
      { key: 'sale_price',   label: 'Satış Fiyatı',    type: 'number' },
      { key: 'purchase_price', label: 'Alış Fiyatı',   type: 'number' },
    ],
  },

  // ───── Stok Hareketi (master-detail için) ─────────────────────
  stock_movement: {
    label: 'Stok Hareketi',
    icon: '🔁',
    fields: [
      { key: 'date',         label: 'Tarih',           type: 'date' },
      { key: 'doc_type',     label: 'Belge Tipi',      type: 'string' },
      { key: 'doc_no',       label: 'Belge No',        type: 'string' },
      { key: 'warehouse',    label: 'Depo',            type: 'string' },
      { key: 'qty_in',       label: 'Giriş Miktar',    type: 'number' },
      { key: 'qty_out',      label: 'Çıkış Miktar',    type: 'number' },
      { key: 'qty',          label: 'Miktar',          type: 'number' },
      { key: 'unit_price',   label: 'Birim Fiyat',     type: 'number' },
      { key: 'amount',       label: 'Tutar',           type: 'number' },
    ],
  },

  // ───── Cari ───────────────────────────────────────────────────
  account: {
    label: 'Cari',
    icon: '👤',
    fields: [
      { key: 'code',         label: 'Cari Kodu',       type: 'string' },
      { key: 'title',        label: 'Ünvan',           type: 'string' },
      { key: 'phone',        label: 'Telefon',         type: 'string' },
      { key: 'mobile',       label: 'Cep Telefonu',    type: 'string' },
      { key: 'email',        label: 'E-posta',         type: 'string' },
      { key: 'tax_office',   label: 'Vergi Dairesi',   type: 'string' },
      { key: 'tax_number',   label: 'Vergi No',        type: 'string' },
      { key: 'id_number',    label: 'TC Kimlik No',    type: 'string' },
      { key: 'address',      label: 'Adres',           type: 'string' },
      { key: 'city',         label: 'Şehir',           type: 'string' },
      { key: 'district',     label: 'İlçe',            type: 'string' },
      { key: 'currency_code',label: 'Para Birimi',     type: 'string' },
      { key: 'balance',      label: 'Bakiye',          type: 'number' },
      { key: 'debit',        label: 'Borç',            type: 'number' },
      { key: 'credit',       label: 'Alacak',          type: 'number' },
    ],
  },

  // ───── Fatura ─────────────────────────────────────────────────
  invoice: {
    label: 'Fatura',
    icon: '🧾',
    fields: [
      { key: 'invoice_no',   label: 'Fatura No',       type: 'string' },
      { key: 'doc_no',       label: 'Belge No',        type: 'string' },
      { key: 'invoice_date', label: 'Tarih',           type: 'date' },
      { key: 'due_date',     label: 'Vade Tarihi',     type: 'date' },
      { key: 'cari_code',    label: 'Cari Kodu',       type: 'string' },
      { key: 'cari_title',   label: 'Cari Ünvan',      type: 'string' },
      { key: 'currency',     label: 'Döviz',           type: 'string' },
      { key: 'subtotal',     label: 'Ara Toplam',      type: 'number' },
      { key: 'discount',     label: 'İskonto',         type: 'number' },
      { key: 'vat_total',    label: 'KDV Toplam',      type: 'number' },
      { key: 'grand_total',  label: 'Genel Toplam',    type: 'number' },
      { key: 'notes',        label: 'Notlar',          type: 'string' },
    ],
  },

  // ───── Fatura Satırı (master-detail için) ─────────────────────
  invoice_line: {
    label: 'Fatura Satırı',
    icon: '📋',
    fields: [
      { key: 'line_no',      label: 'Sıra',            type: 'number' },
      { key: 'stock_code',   label: 'Stok Kodu',       type: 'string' },
      { key: 'stock_name',   label: 'Stok Adı',        type: 'string' },
      { key: 'barcode',      label: 'Barkod',          type: 'string' },
      { key: 'qty',          label: 'Miktar',          type: 'number' },
      { key: 'unit',         label: 'Birim',           type: 'string' },
      { key: 'unit_price',   label: 'Birim Fiyat',     type: 'number' },
      { key: 'discount_rate',label: 'İskonto %',       type: 'number' },
      { key: 'vat_rate',     label: 'KDV %',           type: 'number' },
      { key: 'line_total',   label: 'Satır Tutarı',    type: 'number' },
    ],
  },

  // ───── Personel ───────────────────────────────────────────────
  personnel: {
    label: 'Personel',
    icon: '👔',
    fields: [
      { key: 'code',         label: 'Sicil No',        type: 'string' },
      { key: 'first_name',   label: 'Ad',              type: 'string' },
      { key: 'last_name',    label: 'Soyad',           type: 'string' },
      { key: 'full_name',    label: 'Tam Ad',          type: 'string' },
      { key: 'department',   label: 'Departman',       type: 'string' },
      { key: 'position',     label: 'Pozisyon',        type: 'string' },
      { key: 'phone',        label: 'Telefon',         type: 'string' },
      { key: 'mobile',       label: 'Cep Telefonu',    type: 'string' },
      { key: 'email',        label: 'E-posta',         type: 'string' },
      { key: 'hire_date',    label: 'İşe Giriş',       type: 'date' },
      { key: 'salary',       label: 'Maaş',            type: 'number' },
    ],
  },

  // ───── Belge Başlığı (yazdırılan teklif/fatura/irsaliye/sipariş) ────
  doc_header: {
    label: 'Belge Başlığı',
    icon: '📜',
    fields: [
      { key: 'document_number',     label: 'Belge No',           type: 'string' },
      { key: 'invoice_date',        label: 'Tarih',              type: 'date' },
      { key: 'invoice_time',        label: 'Saat',               type: 'string' },
      { key: 'due_date',            label: 'Vade Tarihi',        type: 'date' },
      { key: 'valid_until',         label: 'Geçerlilik Tarihi',  type: 'date' },
      // Cari
      { key: 'account_code',        label: 'Cari Kodu',          type: 'string' },
      { key: 'account_title',       label: 'Cari Ünvan',         type: 'string' },
      { key: 'account_tax_office',  label: 'Cari Vergi Dairesi', type: 'string' },
      { key: 'account_tax_number',  label: 'Cari VKN/TCKN',      type: 'string' },
      { key: 'account_address',     label: 'Cari Adres',         type: 'string' },
      { key: 'account_city',        label: 'Cari Şehir',         type: 'string' },
      { key: 'account_district',    label: 'Cari İlçe',          type: 'string' },
      { key: 'account_country',     label: 'Cari Ülke',          type: 'string' },
      { key: 'account_phone',       label: 'Cari Telefon',       type: 'string' },
      { key: 'account_mobile',      label: 'Cari Cep',           type: 'string' },
      { key: 'account_email',       label: 'Cari E-posta',       type: 'string' },
      // Personel
      { key: 'personnel_name',      label: 'Hazırlayan',         type: 'string' },
      // Para
      { key: 'currency_code',       label: 'Para Birimi',        type: 'string' },
      { key: 'exchange_rate',       label: 'Kur',                type: 'number' },
      // Toplamlar
      { key: 'subtotal',            label: 'Ara Toplam',         type: 'number' },
      { key: 'discount_total',      label: 'İskonto Toplam',     type: 'number' },
      { key: 'net_total',           label: 'Net Toplam',         type: 'number' },
      { key: 'vat_total',           label: 'KDV Toplam',         type: 'number' },
      { key: 'grand_total',         label: 'Genel Toplam',       type: 'number' },
      { key: 'avg_profit_pct',      label: 'Ortalama Kâr %',     type: 'number' },
      // Notlar
      { key: 'description',         label: 'Açıklama',           type: 'string' },
      { key: 'notes',               label: 'Notlar',             type: 'string' },
      { key: 'internal_notes',      label: 'Dahili Not',         type: 'string' },
    ],
  },

  // ───── Belge Satırı (yazdırılan teklif/fatura/irsaliye/sipariş kalemi) ────
  doc_line: {
    label: 'Belge Satırı',
    icon: '📃',
    fields: [
      { key: 'line_no',          label: 'Sıra No',         type: 'number' },
      { key: 'stock_code',       label: 'Stok Kodu',       type: 'string' },
      { key: 'stock_name',       label: 'Stok / Ürün Adı', type: 'string' },
      { key: 'manual_stock_name',label: 'Manuel Ürün Adı', type: 'string' },
      { key: 'description',      label: 'Açıklama',        type: 'string' },
      { key: 'barcode',          label: 'Barkod',          type: 'string' },
      { key: 'color_name',       label: 'Renk',            type: 'string' },
      { key: 'size_name',        label: 'Beden',           type: 'string' },
      { key: 'quantity',         label: 'Miktar',          type: 'number' },
      { key: 'unit_code',        label: 'Birim',           type: 'string' },
      { key: 'unit_price',       label: 'Birim Fiyat',     type: 'number' },
      { key: 'unit_price_net',   label: 'Birim Fiyat (Net)', type: 'number' },
      { key: 'discount_rate1',   label: 'İskonto1 %',      type: 'number' },
      { key: 'discount_rate2',   label: 'İskonto2 %',      type: 'number' },
      { key: 'discount_rate3',   label: 'İskonto3 %',      type: 'number' },
      { key: 'discount_amount',  label: 'İskonto Tutar',   type: 'number' },
      { key: 'vat_rate',         label: 'KDV %',           type: 'number' },
      { key: 'vat_amount',       label: 'KDV Tutarı',      type: 'number' },
      { key: 'line_net',         label: 'Satır Net',       type: 'number' },
      { key: 'line_total',       label: 'Satır Toplam',    type: 'number' },
      { key: 'personnel_name',   label: 'Satır Personeli', type: 'string' },
    ],
  },

  // ───── Sayfa / Bağlam (rapor üst-alt başlığı için) ────────────
  context: {
    label: 'Sayfa / Bağlam',
    icon: '📄',
    fields: [
      { key: 'title',          label: 'Rapor Başlığı',   type: 'string' },
      { key: 'subtitle',       label: 'Alt Başlık',      type: 'string' },
      { key: 'company_name',   label: 'Firma Adı',       type: 'string' },
      { key: 'filter_summary', label: 'Filtre Özeti',    type: 'string' },
      { key: 'row_count',      label: 'Kayıt Sayısı',    type: 'number' },
      { key: 'footer_text',    label: 'Alt Bilgi',       type: 'string' },
      { key: 'date_today',     label: 'Bugünün Tarihi',  type: 'date' },
      { key: 'page_number',    label: 'Sayfa No',        type: 'number' },
      { key: 'total_pages',    label: 'Toplam Sayfa',    type: 'number' },
    ],
  },
};

// Hangi raporun hangi veri kümelerini kullandığı (master / detail)
export const REPORT_DATA_SOURCES = {
  stock_list:     { master: 'stock',     detail: 'stock_movement' },
  sales_invoice:  { master: 'invoice',   detail: 'invoice_line'   },
  account_list:   { master: 'account',   detail: null             },
  personnel_list: { master: 'personnel', detail: null             },
  // Belge (yazdırma) şablonları — hepsi aynı doc_header/doc_line kümesini paylaşır
  sales_quote_doc:      { master: 'doc_header', detail: 'doc_line' },
  purchase_quote_doc:   { master: 'doc_header', detail: 'doc_line' },
  sales_invoice_doc:    { master: 'doc_header', detail: 'doc_line' },
  purchase_invoice_doc: { master: 'doc_header', detail: 'doc_line' },
  sales_waybill_doc:    { master: 'doc_header', detail: 'doc_line' },
  purchase_waybill_doc: { master: 'doc_header', detail: 'doc_line' },
  sales_order_doc:      { master: 'doc_header', detail: 'doc_line' },
  purchase_order_doc:   { master: 'doc_header', detail: 'doc_line' },
};

// Sürükleme için: master/detail anahtarına göre fiilen kullanılacak veri kümesini ver
export function resolveSourceTypeForKey(sourceKey, layout, reportKey = 'stock_list') {
  const ds = layout?.data_sources?.[sourceKey];
  if (ds?.source_type) return ds.source_type;
  const cfg = REPORT_DATA_SOURCES[reportKey] || REPORT_DATA_SOURCES.stock_list;
  if (sourceKey === 'main') return cfg.master;
  if (sourceKey === 'detail') return cfg.detail;
  if (sourceKey === 'context') return 'context';
  return null;
}

// Bir veri kümesinin alanlarını ver (önce template'in kendi fields'ı, yoksa registry)
export function getFieldsFor(sourceKey, layout, reportKey = 'stock_list') {
  const sourceType = resolveSourceTypeForKey(sourceKey, layout, reportKey);
  if (sourceType && FIELD_REGISTRY[sourceType]) return FIELD_REGISTRY[sourceType].fields;
  // Geriye dönük uyumluluk: eski şablonlarda registry tanınmıyorsa stored fields'ı kullan
  return layout?.data_sources?.[sourceKey]?.fields || [];
}

// Tüm rapor kaynaklarının (yalnızca seçilebilir master tipleri) listesi
export const SELECTABLE_MASTER_SOURCES = ['stock', 'account', 'invoice', 'personnel'];
export const SELECTABLE_DETAIL_SOURCES = ['stock_movement', 'invoice_line', null];
